import React, { useEffect } from 'react';
import styled from 'styled-components';
import BankLogo from '../../assets/img/BankLogo.png';
import MobileImg from '../../assets/img/MobileRequired.png';
import useGAEventsTracker from '../../utils/useGAEventsTrackers';

const Container = styled.div`
  background-color: ${(p) => p.theme.background};
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
  grid-template-rows: 1fr;
  column-gap: 0;
  row-gap: 0rem;
  grid-template-areas: 'sidebar body';
  justify-items: center;
  align-items: stretch;
`;

const Sidebar = styled.div`
  grid-area: sidebar;
  background: linear-gradient(
    0deg,
    rgba(0, 45, 114, 1) 30%,
    rgba(0, 45, 114, 0.82) 50%,
    rgba(0, 45, 114, 1) 70%
  );
  align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const SideImg = styled.img`
  width: 70%;
  border: 7px solid white;
`;

const FullDiv = styled.div`
  grid-area: body;
  background-color: ${(p) => p.theme.background};
`;

const Main = styled.div`
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Header = styled.h2`
  font-size: 2.2rem;
`;

const Subtitle = styled.p`
  width: 60%;
  padding-top: 1.5rem;
  font-size: 1.3rem;
`;

const MainImg = styled.img`
  width: 50%;
  padding-top: 5rem;
`;

function NotMobile() {
  const GAEventsTracker = useGAEventsTracker("Access Error");
  useEffect(() => {
    GAEventsTracker("Ingreso desde una PC");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <Container>
      <Sidebar>
        <SideImg src={BankLogo} alt="Bank Columbia Logo" />
      </Sidebar>
      <FullDiv>
        <Main>
          <Header>¡No es posible acceder a este enlace desde tu
            computadora!</Header>
          <Subtitle>
            Necesitamos que accedas desde tu celular para poder continuar con la
            operación
          </Subtitle>
          <MainImg src={MobileImg} alt="Mobile img" />
        </Main>
      </FullDiv>
    </Container>
  );
}

export default NotMobile;
